import React from "react";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";
import "./assets/scss/theme.scss";
import { NotificationToastContainer } from "./components/Custom/notification";
import NonAuthLayout from "./components/NonAuthLayout";
import VerticalLayout from "./components/VerticalLayout/";
import PageLoader from "./components/Custom/PageLoader";

import {
  authRoutes,
  configurationRoutes,
  dashboardRoutes,
  expenseRoutes,
  managementRoutes,
  undefinedRoutes,
  userRoutes,
} from "./routes/allRoutes";

import Authmiddleware from "./routes/middleware/Authmiddleware";

const App = ({ layout }) => {
  const Layout = VerticalLayout; // Main layout

  const allProtectedRoutes = [
    ...userRoutes,
    ...configurationRoutes,
    ...managementRoutes,
    ...expenseRoutes,
    ...dashboardRoutes,
  ];

  return (
    <>
      <Routes>
        {/* Protected Routes */}
        {allProtectedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <Authmiddleware
                isAuthProtected={true}
                path={route.path}
                settings={route.settings}
                administration={route.administration}
              >
                <Layout>
                  <React.Suspense fallback={<PageLoader />}>
                    {route.element}
                  </React.Suspense>
                </Layout>
              </Authmiddleware>
            }
          />
        ))}

        {/* Non-auth routes */}
        {authRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <Authmiddleware isAuthProtected={false} path={route.path}>
                <NonAuthLayout>
                  <React.Suspense fallback={<PageLoader isFullScreen={true} />}>
                    {route.element}
                  </React.Suspense>
                </NonAuthLayout>
              </Authmiddleware>
            }
          />
        ))}

        {/* Undefined Routes */}
        {undefinedRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <Authmiddleware isAuthProtected={false} path={route.path}>
                <NonAuthLayout>
                  <React.Suspense fallback={<PageLoader isFullScreen={true} />}>
                    {route.element}
                  </React.Suspense>
                </NonAuthLayout>
              </Authmiddleware>
            }
          />
        ))}
      </Routes>

      <NotificationToastContainer />
    </>
  );
};

const mapStateToProps = (state) => ({
  layout: state.Layout,
});

export default connect(mapStateToProps)(App);
